export enum ActionType {
  ASSIGN = 'assign',
  UNASSIGN = 'unassign',
  ADD = 'add',
  REMOVE = 'remove',
  BOTH = 'both', // Used for both add and remove
}

export enum ChatAction {
  UPDATE_DELETE_SKILL = 'UPDATE_DELETE_SKILL',
  UPDATE_DELETE_EDUCATION = 'UPDATE_DELETE_EDUCATION',
  UPDATE_DELETE_CERTS = 'UPDATE_DELETE_CERTS',
  DELETE_ALL_SKILLS = 'DELETE_ALL_SKILLS',
  DELETE_ALL_EDUCATION = 'DELETE_ALL_EDUCATION',
  DELETE_ALL_CERTS = 'DELETE_ALL_CERTS',
}
